import { render, staticRenderFns } from "./SupportEscalation.vue?vue&type=template&id=d0c10ba4&scoped=true"
import script from "./SupportEscalation.vue?vue&type=script&lang=js"
export * from "./SupportEscalation.vue?vue&type=script&lang=js"
import style0 from "./SupportEscalation.vue?vue&type=style&index=0&id=d0c10ba4&prod&scoped=true&lang=css"
import style1 from "./SupportEscalation.vue?vue&type=style&index=1&id=d0c10ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c10ba4",
  null
  
)

export default component.exports